import React from 'react';
import { Route } from '../Routing/types';
import { DietSettingsPage } from '@front-activerse/modules';
import descendantRoutes from './descendantRoutes';
import stepsSchema from './stepsSchema';
import { ALL_DIET_TYPES } from '../GoalSettings/consts';

const dummy_t = (translationKey: string) => translationKey;

const routes: Route[] = [
  {
    path: '/diet-settings/biometric/*',
    element: (
      <DietSettingsPage
        descendantRoutes={descendantRoutes}
        stepsSchema={stepsSchema}
        currentMainStep="biometric"
        dietTypes={ALL_DIET_TYPES}
      />
    ),
    private: true,
    title: dummy_t('userSettings.navbarTitle'),
    mobileAppTabIdentifier: '',
    descendantRoutes,
  },
];

export default routes;
